import {createApp} from 'vue'
import StafetDeltagSomFighterStepTwo from './StafetDeltagSomFighterStepTwo'

const el = '.kb-component--stafet-deltag-som-fighter-step-two'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetDeltagSomFighterStepTwoDOM)=>{
            const component = createApp(StafetDeltagSomFighterStepTwo).use(Store)
            component.mount(StafetDeltagSomFighterStepTwoDOM)
        })
    }
}